import { Building2 } from "lucide-react";
import { useEffect, useState } from "react";

interface MerchantLogoProps {
  src: string;
  alt: string;
  className: string;
  showSkeleton?: boolean;
}

export const LogoPlaceholder = ({
  className,
  icon: Icon = Building2,
}: {
  className: string;
  icon?: React.ComponentType<{ className?: string }>;
}) => (
  <div className={`${className} bg-gray-100 flex items-center justify-center border border-gray-200`}>
    <Icon className="w-4 h-4 text-gray-400" />
  </div>
);

export const MerchantLogo = ({ src, alt, className, showSkeleton = false }: MerchantLogoProps) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (src) {
      setLoading(true);
      setError(false);
    }
  }, [src]);

  const handleLoad = () => {
    setLoading(false);
    setError(false);
  };

  const handleError = () => {
    setLoading(false);
    setError(true);
  };

  if (showSkeleton && loading) {
    return <div className={`${className} bg-gray-200 animate-pulse`} />;
  }

  if (error) {
    return <LogoPlaceholder className={className} />;
  }

  return (
    <>
      {loading && <div className={`${className} bg-gray-200 animate-pulse absolute`} />}
      <img
        src={src}
        alt={alt}
        className={`${className} ${loading ? "opacity-0" : "opacity-100"} transition-opacity duration-200`}
        onLoad={handleLoad}
        onError={handleError}
      />
    </>
  );
};
